import { Injectable }    from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType} from '@angular/http';
import { HttpClient, HttpHeaders  } from '@angular/common/http';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

import { Observable } from 'rxjs';

@Injectable()
export class RequestService {

    private baseRequestUrl = "/Request";  // URL to web api
    private getRequestWithDetailsUrl = '';
    private getRequestsUrl = '';
    private saveRequestUrl = '';
    private deleteRequestUrl = '';
    private emailRequestUrl = '';
    private submitRequestUrl = '';
    private completeRequestUrl = '';
    private inProgressRequestUrl = '';
    private rejectRequestUrl = '';
    private getAttachmentsUrl = '';
    private downloadAttachmentUrl = '';
    private deleteAttachmentsUrl = '';
    private getRequestStatusUrl = '';
    private getRequestActionsUrl = '';
    private getRequestTotalsByTypeAndStatusUrl = '';
    private saveRequestCompletionNumbersUrl = '';
    private exportRequestsUrl = '';
    private processCompletionInfoUrl = '';
    private createCONAEquipmentPayloadUrl = '';
    private createCONADriverPayloadUrl = '';
    private createCONAPartnerFunctionPayloadUrl = '';
  
    appConfig: ent.AppConfig;

    constructor(private http: Http, private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseRequestUrl = this.configService.appConfig.UrlBase + this.baseRequestUrl;

        this.getRequestsUrl = this.baseRequestUrl + '/GetRequests';
        this.getRequestWithDetailsUrl = this.baseRequestUrl + '/GetRequestWithDetails';
        this.saveRequestUrl = this.baseRequestUrl + '/SaveRequest';
        this.deleteRequestUrl = this.baseRequestUrl + '/DeleteRequest';
        this.emailRequestUrl = this.baseRequestUrl + '/EmailRequest';
        this.submitRequestUrl = this.baseRequestUrl + '/SubmitRequest';
        this.completeRequestUrl = this.baseRequestUrl + '/CompleteRequest';
        this.inProgressRequestUrl = this.baseRequestUrl + '/InProgressRequest';
        this.rejectRequestUrl = this.baseRequestUrl + '/RejectRequest';
        this.getAttachmentsUrl = this.baseRequestUrl + '/GetAttachments';
        this.deleteAttachmentsUrl = this.baseRequestUrl + '/DeleteAttachments';
        this.downloadAttachmentUrl = this.baseRequestUrl + '/DownloadAttachment';
        this.getRequestStatusUrl = this.baseRequestUrl + '/GetRequestStatus';
        this.getRequestActionsUrl = this.baseRequestUrl + '/GetRequestActions';
        this.getRequestTotalsByTypeAndStatusUrl = this.baseRequestUrl + '/GetRequestTotalsByTypeAndStatus';
        this.saveRequestCompletionNumbersUrl = this.baseRequestUrl + '/SaveRequestCompletionNumbers';
        this.exportRequestsUrl = this.baseRequestUrl + '/ExportRequests';
        this.processCompletionInfoUrl = this.baseRequestUrl + '/ProcessCompletionInfo';
        this.createCONAEquipmentPayloadUrl = this.baseRequestUrl + '/CreateCONAEquipmentPayload';
        this.createCONADriverPayloadUrl = this.baseRequestUrl + '/CreateCONADriverPayload';
        this.createCONAPartnerFunctionPayloadUrl = this.baseRequestUrl + '/CreateCONAPartnerFunctionPayload';
    }

    saveRequest(request: ent.Request): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveRequestUrl, request);
    }

    deleteRequest(filter: filters.RequestFilter): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.deleteRequestUrl, filter);
    }

    getRequestWithDetails(filter: filters.RequestFilter): Observable<ent.Request> {
        return this.httpClient.post<ent.Request>(this.getRequestWithDetailsUrl, filter);
    }

    getRequests(filter: filters.RequestFilter): Observable<ent.Request[]> {
        return this.httpClient.post<ent.Request[]>(this.getRequestsUrl, filter);
    }

    emailRequest(filter: filters.RequestFilter): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.emailRequestUrl, filter);
    }

    submitRequest(filter: filters.RequestFilter): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.submitRequestUrl, filter);
    }

    completeRequest(filter: ent.CompleteRequestsRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.completeRequestUrl, filter);
    }

    inProgressRequest(filter: filters.RequestFilter): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.inProgressRequestUrl, filter);
    }

    rejectRequest(filter: filters.RequestFilter): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.rejectRequestUrl, filter);
    }

    getAttachments(filter: filters.RequestFilter): Observable<ent.Attachment[]> {
        return this.httpClient.post<ent.Attachment[]>(this.getAttachmentsUrl, filter);
    }

    downloadAttachment(request: ent.DownloadAttachmentRequest): Observable<any> {

        
        let options = new RequestOptions({responseType: ResponseContentType.Blob});
        return this.http.post(this.downloadAttachmentUrl, request, options)
            .map((res: any) => {
                let data = {
                               image: new Blob([res._body], {type: res.headers.get('Content-Type')}),
                               filename: res.headers.get('file-name')
                            };
              return data ;
            });
    }

    deleteAttachments(attachments: ent.Attachment[]): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.deleteAttachmentsUrl, attachments);
    }

    getRequestStatus(filter: filters.RequestFilter): Observable<number> {
        return this.httpClient.post<number>(this.getRequestStatusUrl, filter);
    }

    getRequestActions(filter: filters.RequestFilter): Observable<ent.RequestAction[]> {
        return this.httpClient.post<ent.RequestAction[]>(this.getRequestActionsUrl, filter);
    }

    getRequestTotalsByTypeAndStatus(filter: filters.RequestFilter): Observable<ent.RequestTotalsByTypeAndStatus[]> {
        return this.httpClient.post<ent.RequestTotalsByTypeAndStatus[]>(this.getRequestTotalsByTypeAndStatusUrl, filter);
    }

    saveRequestCompletionNumbers(request: ent.Request): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveRequestCompletionNumbersUrl, request);
    }

    exportRequests(request: ent.ExportRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.exportRequestsUrl, request);
    }

    processCompletionInfo(request: ent.ProcessCompletionInfoRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.processCompletionInfoUrl, request);
    }

    createCONAPayloadForEquipment(request: ent.CONAEquipmentPayloadRequest): Observable<ent.CONAPayloadResponse> {
        return this.httpClient.post<ent.CONAPayloadResponse>(this.createCONAEquipmentPayloadUrl, request);
    }

    createCONAPayloadForDriver(request: ent.CONADriverPayloadRequest): Observable<ent.CONAPayloadResponse> {
        return this.httpClient.post<ent.CONAPayloadResponse>(this.createCONADriverPayloadUrl, request);
    }

    createCONAPayloadForPartnerFunction(request: ent.CONAPartnerFunctionPayloadRequest): Observable<ent.CONAPayloadResponse> {
        return this.httpClient.post<ent.CONAPayloadResponse>(this.createCONAPartnerFunctionPayloadUrl, request);
    }

}
